/**
 * Prism.js syntax highlighting
 * https://prismjs.com/
 */

import Prism from 'prismjs';

// Languages
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-markup';

// Plugins
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

// Styles
import 'prismjs/themes/prism-okaidia.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('pre code').forEach((codeBlock) => {
    const pre = codeBlock.parentElement;
    if (!pre.classList.contains('line-numbers')) {
      pre.classList.add('line-numbers');
    }
  });

  Prism.highlightAll();
});
